import React, { Component } from 'react';
import Comic from './Comic.js';
import NewComicBookForm from './NewComicBookForm.js';
import './ComicList.css';


class ComicList extends Component {
    constructor(props) {
        console.log("in constructor");
        super(props);
        this.state = {
            /*comics: [{ issue: 19, order: 2, title: "Venom", id: 123, copySecured: false, variant: "", extraCopy: false }, { issue: 25, order: 0, title: "Amazing Spider-Man", id: 124, copySecured: false, variant: "", extraCopy: false }, { issue: 22, order: 3, title: "X-Men", id: 125, copySecured: false, variant: "", extraCopy: false }, { issue: 25, order: 1, title: "Amazing Spider-Man", id: 126, copySecured: false, variant: "Skottie Young Variant", extraCopy: false }, { issue: 11, order: 1, title: "Daredevil", id: 127, copySecured: false, variant: "", extraCopy: false }, { issue: 22, order: 3, title: "X-Men", id: 128, copySecured: false, variant: "", extraCopy: true }, { issue: 23, order: 3, title: "Moon Knight", id: 130, copySecured: false, variant: "", extraCopy: false }]*/
            comics: JSON.parse(window.localStorage.getItem("comics") || "[]")
            
        }
        this.addComic = this.addComic.bind(this);
        this.removeComic = this.removeComic.bind(this);
        this.updateComic = this.updateComic.bind(this);
        this.secureComic = this.secureComic.bind(this);
    }
    addComic(newComic) {
        this.setState(st => ({
            comics: [...st.comics, newComic]
        }));
    }
    removeComic(id) {
        this.setState({
            comics: this.state.comics.filter(comic => comic.id !== id)
        });
    }
    updateComic(id, updatedTitle, updatedIssueNum, updatedVariant) {
        const updatedComics = this.state.comics.map(comic => {
            if (comic.id === id) {
                return {...comic, title: updatedTitle, issue: updatedIssueNum, variant: updatedVariant}
            }
            return comic;
        })

        this.setState({
            comics: updatedComics
        });
    }
    secureComic(id) {
        const updatedComics = this.state.comics.map(comic => {
            if (comic.id === id) {
                return {...comic, copySecured: !comic.copySecured}
            }
            return comic;
        })

        this.setState({
            comics: updatedComics
        })
    }

    componentDidUpdate() {
        window.localStorage.setItem(
            "comics",
            JSON.stringify(this.state.comics)
        );
        console.log("in component Did Update");
    }

    render() {
        /*const newComicList = this.state.comics.map(comic => (
            <Comic
                key={comic.id}
                id={comic.id}
                title={comic.title}
                variant={comic.variant}
                copySecured={comic.copySecured}
                extraCopy={comic.extraCopy}
                order={comic.order}
                removeComic={this.removeComic}
                updateComic={this.updateComic}
                secureComic={this.secureComic}}
            />
        ));
     */
        console.log("in initial render");
        const newComicList = [].concat(this.state.comics)
                .sort((c1, c2) => (c1.title > c2.title) ? 1 : (c1.title < c2.title) ? -1 : 0)
                .map(comic => (
                    <Comic
                        key={comic.id}
                        id={comic.id}
                        title={comic.title}
                        issue={comic.issue}
                        variant={comic.variant}
                        copySecured={comic.copySecured}
                        extraCopy={comic.extraCopy}
                        //order={comic.order}
                        removeComic={this.removeComic}
                        updateComic={this.updateComic}
                        secureComic={this.secureComic}
                    />
                ));
        
        return (
            <div className="ComicList">
                <h1 className="project-h1">New Comic Books For The Week!</h1>
                <NewComicBookForm addComic={this.addComic} />
                    {newComicList}
                
            </div>
            )
    }
}

export default ComicList;